/**
 * @generated SignedSource<<da568756ea79f76a3a9f6b97cd37565e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobExamDetailQuery$variables = {
  jobExamId: string;
};
export type JobExamDetailQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JobExamDetail_query">;
};
export type JobExamDetailQuery = {
  response: JobExamDetailQuery$data;
  variables: JobExamDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jobExamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JobExamDetailQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "jobExamId",
            "variableName": "jobExamId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "JobExamDetail_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JobExamDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Candidate",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "jobExam",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "jobExamId"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "approvedMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasApplied",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reprovedMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JobRole",
                "kind": "LinkedField",
                "name": "jobRole",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "QuestionWeight",
                "kind": "LinkedField",
                "name": "questionsWeight",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobExamQuestion",
                    "kind": "LinkedField",
                    "name": "question",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JobExamQuestionOption",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weight",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "JobExam",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3f70374f6aafb05e8afbac9af45ad319",
    "id": null,
    "metadata": {},
    "name": "JobExamDetailQuery",
    "operationKind": "query",
    "text": "query JobExamDetailQuery(\n  $jobExamId: ID!\n) {\n  ...JobExamDetail_query_1b2Sey\n}\n\nfragment JobExamDetail_query_1b2Sey on Query {\n  me {\n    id\n  }\n  jobExam: node(id: $jobExamId) {\n    __typename\n    ... on JobExam {\n      id\n      title\n      approvedMessage\n      hasApplied\n      reprovedMessage\n      timeLimit\n      jobRole {\n        name\n        id\n      }\n      questionsWeight {\n        question {\n          id\n          title\n          type\n          options {\n            value\n          }\n        }\n        weight\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f559acdf3b524b416f5c58dd52270f46";

export default node;
